export function DesignFace({
  name,
  imageUrl,
  swatch,
  fit = "cover",
}: {
  name: string;
  imageUrl: string | null;
  swatch: string | null;
  fit?: "cover" | "contain";
}) {
  return (
    <div className="relative h-full w-full">
      {imageUrl ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={imageUrl}
          alt={name}
          className={`absolute inset-0 h-full w-full ${fit === "contain" ? "object-contain" : "object-cover"}`}
        />
      ) : swatch ? (
        <div className="absolute inset-0" style={{ background: swatch }} />
      ) : (
        <div className="absolute inset-0 grid place-items-center bg-[linear-gradient(160deg,#f6d7dd,#f3e6c4)]">
          <span className="font-serif text-4xl text-rose-deep">{name.slice(0, 1)}</span>
        </div>
      )}
    </div>
  );
}
